
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}img{aspect-ratio:var(--aspect-ratio);border-radius:var(--border-radius);height:auto;max-width:var(--max-width);object-fit:cover;width:100%}[cloned-slot-name=title]{padding-bottom:var(--spacing-6)}.caption{color:var(--color-font-content);font-family:var(--ff-body);font-size:var(--fs-sm);line-height:var(--lh-base)}`;